import { Component, Input, ViewEncapsulation } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fs-message-card',
  templateUrl: './message-card.component.html',
  styleUrls: ['./message-card.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class MessageCardComponent {
  @Input() cardClass: string;
  faTimes = faTimes;
  showCard: boolean = true;

  constructor() { }

  onClickCross() {
    this.showCard = false;
  }
}
